import { render, staticRenderFns } from "./MapaDesempenho.vue?vue&type=template&id=5167e40d&scoped=true"
import script from "./MapaDesempenho.vue?vue&type=script&lang=js"
export * from "./MapaDesempenho.vue?vue&type=script&lang=js"
import style0 from "./MapaDesempenho.vue?vue&type=style&index=0&id=5167e40d&prod&lang=css"
import style1 from "./MapaDesempenho.vue?vue&type=style&index=1&id=5167e40d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5167e40d",
  null
  
)

export default component.exports